import React, { useEffect, useState } from 'react';

interface apiConfigResponse {
  is_touch_screan: boolean;
  is_vertical_screan: boolean;
}

interface KioskConfigContextInterface {
  showPollBtn: boolean;
}

export const KioskConfigContext = React.createContext<KioskConfigContextInterface>({
  showPollBtn: false,
});

export const KioskConfigContextProvider = ({ children }: { children: any }) => {
  const [showPollBtn, setAnswers] = useState<boolean>(false);

  useEffect(() => {
    getConfig();
    const l = setInterval(() => {
      getConfig();
    }, 60 * 1000);
    return () => {
      clearInterval(l);
    };
  }, []);

  const getConfig = () => {
    fetch('/api/v1/config/', {
      method: 'GET',
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    })
      .then((r) => r.json())
      .then((data: apiConfigResponse) => {
        setAnswers(data.is_touch_screan);
      });
  };

  return <KioskConfigContext.Provider value={{ showPollBtn }}>{children}</KioskConfigContext.Provider>;
};
